"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const difference_1 = tslib_1.__importDefault(require("lodash/difference"));
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../../helpers/enrolment/getEnrolmentOfContent"));
const updateEnrolmentFields_1 = require("../../helpers/enrolment/updateEnrolmentFields");
const getCheckpointReviewerChangedEvent_1 = require("../../helpers/getEvent/getCheckpointReviewerChangedEvent");
const getState_1 = require("../../helpers/getState");
const entity_1 = require("../../type/entity");
const zeroStateInteractionsOfCheckpoint_1 = require("../../zeroStateInteractions/zeroStateInteractionsOfCheckpoint");
const getReviewerSetting_1 = require("./getReviewerSetting");
const updateExistingStateInteractions_1 = require("./updateExistingStateInteractions");
function applyChangeReviewerCommand(command, user, content, states, enrolments, stateInteractions) {
    const events = [];
    const { reviewerSetting, rootContentId, timeStamp } = command;
    const { userId } = user;
    const updatedModels = immer_1.default({ events, states, enrolments, stateInteractions }, inputModel => {
        const { events: draftEvents, states: draftStates, enrolments: draftEnrolments, stateInteractions: draftStateInteractions } = inputModel;
        const currentEnrolment = getEnrolmentOfContent_1.default(draftEnrolments, rootContentId, userId);
        const currentState = getState_1.getStateByContentIdUserId(draftStates, rootContentId, userId);
        if (currentState.CompletionStatus !== entity_1.CompletionStatus.COMPLETE) {
            const existingReviewerIds = currentEnrolment.reviewerIds;
            const existingReviewerType = currentEnrolment.reviewerType;
            // setting reviewerIds empty array for reviewerType none.
            if (reviewerSetting.reviewerType === entity_1.ReviewerType.NONE || reviewerSetting.reviewerType === entity_1.ReviewerType.MANAGER) {
                currentEnrolment.reviewerIds = [];
            }
            else if (reviewerSetting.reviewerType === entity_1.ReviewerType.USER) {
                currentEnrolment.reviewerIds = reviewerSetting.reviewerIds;
                /**
                 * creating new stateInteractions only if pending submission exists.
                 * As stateInteractions are only created when a user submits in a checkpoint.
                 */
                if (currentState.completionStatus === entity_1.CompletionStatus.COMPLETE &&
                    currentState.successStatus === entity_1.CheckpointSuccessStatus.NA) {
                    const currentSubmission = currentState.submissions[0];
                    const newReviewerIds = difference_1.default(reviewerSetting.reviewerIds, existingReviewerIds);
                    newReviewerIds.forEach(reviewerId => {
                        const newStateInteraction = zeroStateInteractionsOfCheckpoint_1.zeroStateInteractionsOfCheckpoint(content, user, currentSubmission.submissionId, reviewerId, timeStamp);
                        draftStateInteractions.push(newStateInteraction);
                    });
                }
            }
            else if (reviewerSetting.reviewerType === entity_1.ReviewerType.GROUP) {
                currentEnrolment.reviewerIds = reviewerSetting.reviewerIds;
            }
            /**
             * updating existing stateInteractions only if pending submission exists.
             * As stateInteractions are only created when a user submits in a checkpoint.
             */
            if (currentState.completionStatus === entity_1.CompletionStatus.COMPLETE &&
                currentState.successStatus === entity_1.CheckpointSuccessStatus.NA) {
                currentState.submissions.forEach((currentSubmission) => {
                    const incomingReviewerIds = reviewerSetting.reviewerIds;
                    const removedReviewerIds = difference_1.default(existingReviewerIds, incomingReviewerIds || []);
                    updateExistingStateInteractions_1.updateExistingStateInteractions(currentSubmission, removedReviewerIds, rootContentId, timeStamp, draftStateInteractions);
                });
            }
            currentEnrolment.reviewerType = reviewerSetting.reviewerType;
            updateEnrolmentFields_1.updateDates(command, currentEnrolment);
            const previousReviewerSetting = getReviewerSetting_1.getReviewerSetting(existingReviewerIds, existingReviewerType);
            const reviewerChangedEvent = getCheckpointReviewerChangedEvent_1.getCheckpointReviewerChangedEvent(command, user, content, previousReviewerSetting, reviewerSetting);
            draftEvents.push(reviewerChangedEvent);
        }
        else if (currentState.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            throw new Error('Cannot change approver, Checkpoint Completed');
        }
    });
    return {
        states: updatedModels.states,
        events: updatedModels.events,
        enrolments: updatedModels.enrolments,
        stateInteractions: updatedModels.stateInteractions
    };
}
exports.applyChangeReviewerCommand = applyChangeReviewerCommand;
//# sourceMappingURL=index.js.map